<app-loading *ngIf="!isLoaded && !isGuestUser "></app-loading>
<app-header *ngIf="isLoaded && !isGuestUser">

</app-header>
<div class="bg-gray-100 min-h-screen" [hidden]="!isLoaded || isGuestUser">
  <section class="relative w-full h-auto flex justify-center items-start bg-gray-#f2f2f2 pb-5">
    <div class="w-[350px]">
      <mat-stepper *ngIf="isLanguageLoaded" labelPosition="bottom" [disableRipple]="true" #stepper
                   class="hidden-stepper bg-gray-#f2f2f2">
        <mat-step class="hidden">
          <app-payments
                        (isBolsaTransfer)="setIsBolsaTransfer($event)"
                        [isBolsaTransferInput]="isBolsaTransfer"
                        [total]="totalAmountUsd" [totalDisplayInCurrency]="total"
                        [paymentRoute]="paymentRoute" [exchangeRate]="exchangeRate"
                        [orderId]="orderId" [currency]="currency"
                        [orderNumber]="orderNumber"
                        [paymentBreakdown]="paymentBreakdownDecoded"
                        [userPaymentRequest]="userPaymentRequest"
                        [redirect]="redirect"
                        (isLoaded)= "loadCompleted()"
                        (next)="changeStepper($event)">
          </app-payments>
        </mat-step>

        <!--   todo poner la barrera de paso final aqui y verificar como   validarla   -->

        <mat-step class="hidden" *ngIf="isBolsaTransfer">
          <ng-template matStepLabel>{{ 'QR' | translate }}</ng-template>
          <app-new-cart-qr-transfer *ngIf="stepper.selectedIndex === 1"
                                    (next)="changeStepper($event)">
          </app-new-cart-qr-transfer>
        </mat-step>
      </mat-stepper>
    </div>
  </section>
</div>
<app-guest-payment *ngIf="isGuestUser"></app-guest-payment>
